import { RootState } from '../../store/store'

export const selectMessagesUnreadCount = (state: RootState): number => {
  const user = state.account.user
  const unread = state.messagesUnread
  if (!user?.id || unread?.userId !== user.id || unread.competenceId !== (user.competence?.id || 0)) return 0
  return Object.values(unread.counts).reduce((total, count) => total + count, 0)
}

export const selectQuestionsUnreadCount = (state: RootState): number => {
  const total = selectMessagesUnreadCount(state)
  if (!total) return 0
  return (state.messagesUnread.questionTopicIds || []).reduce(
    (count, id) => count + (state.messagesUnread.counts[id] || 0),
    0,
  )
}

export const selectDiscussionsUnreadCount = (state: RootState): number =>
  selectMessagesUnreadCount(state) - selectQuestionsUnreadCount(state)
